import type { ReactNode } from "react";
import { Flex, Typography } from "antd";

export function PageHeading({ title, description, action }: {
  readonly title: string;
  /** Chuỗi mô tả, hoặc node khi header band cần mang badge/meta nghiệp vụ cùng dòng. */
  readonly description?: ReactNode;
  readonly action?: ReactNode;
}) {
  return (
    <Flex className="page-heading" align="flex-start" justify="space-between" gap="middle">
      <div>
        <Typography.Title level={1}>{title}</Typography.Title>
        {description === undefined ? null : (
          <Typography.Paragraph>{description}</Typography.Paragraph>
        )}
      </div>
      {action}
    </Flex>
  );
}
